import React from 'react';
import styles from './TableContent.module.scss';
import PropTypes from 'prop-types';
import { Table, Switch, } from 'antd';
import { XPagination, } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, tooltipClick } from '@/components/TableCell';
import { FormOutlined } from '@ant-design/icons';

class CardTable extends React.PureComponent {
    columns = () => [
        {
            title: '卡券名称',
            dataIndex: 'couponName',
            key: 'couponName',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => this.props.tableAction(record.id, 'detail'))
        },
        {
            title: '名称备注',
            dataIndex: 'couponDesc',
            key: 'couponDesc',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '卡券类型',
            dataIndex: 'couponTypeDesc',
            key: 'couponTypeDesc',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发放时间',
            dataIndex: 'issue',
            key: 'issue',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '库存',
            dataIndex: 'leftNum',
            key: 'leftNum',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => this.inventoryRender(text, record)
        },
        {
            title: '发放状态',
            dataIndex: 'issueStatusDesc',
            key: 'issueStatusDesc',
            align: 'center',
            width: cellWidth.normal,
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推广类型',
            dataIndex: 'useTypeDesc',
            key: 'useTypeDesc',
            align: 'center',
            width: cellWidth.normal,
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '启用状态',
            dataIndex: 'status',
            key: 'status',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => (this.switchCell(text, record))
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 240,
            fixed: 'right',
            render: (id, record) => this.tableAction(id, record)
        }
    ];

    //操作
    tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(id, 'edit')}>编辑</div>
                <div className={styles.item} onClick={() => tableAction(id, 'getDetail',record)}>明细</div>
                <div className={styles.item} onClick={() => tableAction(id, 'delete')}>删除</div>
            </div >
        );
    };

    //库存
    inventoryRender = (text, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.sort_box} onClick={() => tableAction(record, 'inventory')}>
                {tooltip(text)}
                <div className={styles.icon}> <FormOutlined /></div>
            </div>
        );
    }

    //状态
    switchCell = (sw, item) => {
        let checked = true;
        if (sw == '0') {
            checked = false;
        }
        return (
            <Switch
                checkedChildren="ON"
                unCheckedChildren="OFF"
                checked={checked}
                onChange={(value) => {
                    this.props.tableAction(item, 'switch', value);
                }}
            />
        );
    };

    // 解析表格数据
    _takeDataSource = (data) => {
        // 解析表格数据，使符合columns格式要求
        return data.map(item => {
            item.issue = `${item.issueStartTime ? item.issueStartTime : ''} 至 ${item.issueEndTime ? item.issueEndTime : ''}`;//发放时间
            return item;
        });
    }


    render() {
        const { paginationChange } = this.props;
        const { dataList, pageSize, pageNum, resultTotal } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowSelection={this._rowSelection}
                    rowKey={(record) => record.id}
                    columns={this.columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ x: 'max-content', y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

CardTable.propTypes = {
    renderData: PropTypes.object, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default CardTable;